import { memo, useMemo, useState, useCallback } from 'react';
import { Chip, Popover } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { logEvent } from 'utils/tracking';
import VariablesPopover from './VariablesPopover';

import './styles.scss';

const VariablesSelector = ({ onApply }) => {
    const [visible, setVisible] = useState(false);

    const onClick = useCallback((e) => {
        logEvent({
            event: 'emails',
            submodule: 'genericVars',
            functionality: 'insert',
        });
        setVisible((currentVisible) => !currentVisible);
    }, []);

    const onApplyVariable = useCallback(
        (variable) => {
            onApply(variable);
            setVisible(false);
        },
        [onApply],
    );

    const popoverProps = useMemo(
        () => ({
            className: 'fm-ee__variables-popover',
            placement: 'bottomLeft',
            visible,
            onVisibleChange: setVisible,
            content: <VariablesPopover onApply={onApplyVariable} />,
        }),
        [onApplyVariable, visible],
    );

    return (
        <Popover {...popoverProps}>
            <Chip onClick={onClick} icon="variables" size="large" isUnfolded>
                {getLiteral('title_insert_fields')}
            </Chip>
        </Popover>
    );
};

export default memo(VariablesSelector);
